(ns frontend.view.components.timeline.entry.task-reactivate
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [frontend.routing :as routing]
            [common.localization :as loc]
            [clojure.string :as string]))

;;TODO update later to jump to actual task instead of task listing
(defn open-task [{:keys [audit/target] :as entry}]
  (routing/set-view! [:tasks-grid] {:filter :all-pending}))

(defn title-generator [entry]
  (let [name (-> entry :audit/account :account/first-name)]
    (loc/tr (-> entry :audit/op) [name])))

(defmethod te/timeline-entry-view :op.task/reactivate [{entry :entry}]
  [default/timeline-item-view entry title-generator default/body-generator
   default/timestamp-generator
   (fn [] (open-task entry))])
